import { getCalendarEvent, getEventsForUpNextDateRange } from './calendarLoaderStoreSelectors';
import { getUpNextStore } from '../store/store';
import { getUpNextEventConflicts } from '../utils/getUpNextEventConflicts';
import { CalendarCacheScenarioId } from 'owa-calendar-cache';
import { CalendarEvent } from 'owa-calendar-types';
import { ClientItemId } from 'owa-client-ids';

/** get the stored up-next event ID from the store */
export function getUpNextCalendarEventId(scenarioId: CalendarCacheScenarioId): ClientItemId | null {
    return getUpNextStore().scenarios.get(scenarioId);
}

export function getUpNextCalendarEvent(scenarioId: CalendarCacheScenarioId): CalendarEvent | null {
    const upNextItemIdForGivenScenario = getUpNextCalendarEventId(scenarioId);

    // No up-next event exists for the given calendar scenario
    if (!upNextItemIdForGivenScenario) {
        return null;
    }
    return getCalendarEvent(scenarioId, upNextItemIdForGivenScenario);
}

export function getUpNextConflictingCalendarEventIds(
    scenarioId: CalendarCacheScenarioId
): ClientItemId[] {
    return getUpNextConflictingCalendarEvents(scenarioId).map(event => event.ItemId);
}

export function getUpNextConflictingCalendarEvents(
    scenarioId: CalendarCacheScenarioId
): CalendarEvent[] {
    const currentUpNextEvent = getUpNextCalendarEvent(scenarioId);
    return currentUpNextEvent
        ? getUpNextEventConflicts(currentUpNextEvent, getEventsForUpNextDateRange(scenarioId))
        : [];
}

export function isUpNextScenarioInitialized(scenarioId: CalendarCacheScenarioId): boolean {
    return getUpNextStore().scenarios.has(scenarioId);
}

export function getInitializedScenarioIds(): CalendarCacheScenarioId[] {
    return [...getUpNextStore().scenarios.keys()];
}
